import Text from '../../../components/Text';
import { fontSizes } from '../../../constants/constants';
import dynamicfunction from '../../../utils/dynamicfunction';
import ImagesSlide from '../../../components/ImagesSlide';
import ViewReverse from '../../../components/ViewReverse';
import { useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { formatNumbers, getContentKeyAccToLang } from '../../../utils/utils';
import dayjs from 'dayjs';

const SubscribeCard = ({ item }) => {
  const navigate = useNavigate();
  const { TextWeight, isArabic } = dynamicfunction();

  const { investmentContent } = useSelector((state) => state.content);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      investmentContent?.web_investment_fund?.data?.attributes,
      key,
      isArabic
    );
  };

  const images_array = item?.documents?.filter(
    (val) => val?.documentTypeId === 5
  );

  return (
    <div className='rounded-xl sm:rounded-2xl border border-lavender bg-white p-2.5 sm:p-3 w-full'>
      <ImagesSlide images={images_array} imagesStyle={'h-40 sm:h-48'} />
      <ViewReverse className='justify-between items-center mt-4 mb-2'>
        <Text
          text={item?.fundName}
          size={fontSizes.h16}
          weight={TextWeight.semiBold}
          isTruncate={false}
          color='text-black'
          className={'mt-4 mb-2'}
        />
        <Text
          text={`${formatNumbers(item?.fundedPercentage)}% ${getContentKey(
            'funded'
          )}`}
          weight={TextWeight.semiBold}
          color='text-primary'
        />
      </ViewReverse>

      <div className='mb-3'>
        <Text
          text={item?.longDesc}
          weight={TextWeight.light}
          isTruncate={false}
        />
      </div>

      <>
        <ViewReverse className='justify-between items-center mb-2'>
          <div>
            <Text text={getContentKey('fund_size')} color='text-black' />
            <ViewReverse isReverse={false}>
              <Text
                text={item?.fundSize}
                size={fontSizes.h14}
                weight={TextWeight.semiBold}
                color='text-primary'
              />
            </ViewReverse>
          </div>
          <div>
            <Text text={getContentKey('duration')} color='text-black' />
            <Text
              text={item?.duration}
              size={fontSizes.h14}
              weight={TextWeight.semiBold}
              color='text-primary'
              align={isArabic ? 'text-left' : 'text-right'}
            />
          </div>
          <div>
            <Text text={getContentKey('land_area')} color='text-black' />
            <Text
              text={item?.landArea}
              size={fontSizes.h14}
              weight={TextWeight.semiBold}
              color='text-primary'
            />
          </div>
          <div>
            <Text text={getContentKey('start_date')} color='text-black' />
            <Text
              text={dayjs(item?.startDate).format('YYYY')}
              size={fontSizes.h14}
              weight={TextWeight.semiBold}
              color='text-primary'
              align={isArabic ? 'text-left' : 'text-right'}
            />
          </div>
        </ViewReverse>
      </>
    </div>
  );
};
export default SubscribeCard;
